import React, { useState } from 'react';
import dayjs from 'dayjs';
import { Menu } from '@mantine/core';
import { findMatchingDatesRangeOption, } from './date-range-options';
import { FilterButton } from '../filter-button';
import { DateRangeFilterDropdown } from './date-range-filter-dropdown';
const getSelectedLabel = (value) => {
    const hasSelectedRange = value.every((v) => v !== null);
    if (hasSelectedRange && value[0] && value[1]) {
        if (dayjs(value[0]).isSame(value[1], 'day')) {
            if (dayjs(value[0]).isSame(dayjs(), 'day')) {
                return 'Today';
            }
            return dayjs(value[0]).format('D MMM YYYY');
        }
        return value.map((v) => dayjs(v).format('D MMM YYYY')).join(' - ');
    }
    return undefined;
};
/**
 * A filter component that allows users to date ranges from a dropdown menu and displays the selection.
 */
export const DateRangeFilter = ({ clearable = false, label, onChange: onChangeProp, value: valueProp, menuProps, rangeOptions, onClose, initialValue, onRangeOptionChange: onRangeOptionChangeProp, rangeOptionsTitle, bottomSection, ...buttonProps }) => {
    const [opened, setOpened] = useState(false);
    const [valueInternal, setValueInternal] = useState(initialValue ?? [null, null]);
    const [rangeOption, setRangeOption] = useState(() => {
        if (rangeOptions && initialValue) {
            return findMatchingDatesRangeOption(initialValue, rangeOptions);
        }
        return undefined;
    });
    const onChange = (val) => {
        setValueInternal(val);
        onChangeProp?.(val);
    };
    const value = valueProp ?? valueInternal;
    const onChangeRangeOption = (rangeOption) => {
        if (!rangeOption)
            return;
        setRangeOption(rangeOption);
        setValueInternal(rangeOption.range);
        // setDate(rangeOption.range[0] ?? new Date());
        onRangeOptionChangeProp?.(rangeOption);
        onChangeProp?.(rangeOption.range);
    };
    const hasSelectedRange = value.every((v) => v !== null);
    const selectedLabel = rangeOption?.label ?? getSelectedLabel(value);
    return (<Menu position='bottom-start' {...menuProps} onOpen={() => setOpened(true)} onClose={() => {
            onClose?.();
            setOpened(false);
        }} closeOnItemClick={false} shadow='sm' middlewares={{
            shift: false,
        }}>
      <Menu.Target>
        <FilterButton label={label} selectedLabel={selectedLabel} opened={opened} {...buttonProps} variant={hasSelectedRange ? 'light' : 'outline'} onClick={() => { }}/>
      </Menu.Target>

      <Menu.Dropdown p={0}>
        <DateRangeFilterDropdown clearable={clearable} label={label} onChange={onChange} value={value} initialValue={initialValue} 
    // @ts-expect-error -- TODO
    onRangeOptionChange={onChangeRangeOption} rangeOptions={rangeOptions} onClose={onClose} rangeOptionsTitle={rangeOptionsTitle} bottomSection={bottomSection} {...buttonProps}/>
      </Menu.Dropdown>
    </Menu>);
};
